import { Logo } from "@olivahealth/oli-ui";
import tokens from "@olivahealth/oli-ui/theme/tokens";
import { CenteredInfinityLoader } from "../../../molecules/Loaders/InfinityLoader";
import { DarkModePageLayout } from "../../../components/DarkModePageLayout";
import * as s from "./styles";

export default function InitialLoader() {
  return (
    <>
      {/* Mobile Header */}
      <header className={s.headerContainer}>
        <div className="flex items-center">
          <Logo height={28} color="white" />
        </div>
        <div className={s.mobileHeaderButton} />
      </header>

      {/* Sidebar for Desktop */}
      <div className={s.sidebarContainer}>
        <div className="mb-10 flex items-center p-2.5 md:px-6">
          <Logo height={28} color="white" />
        </div>

        <div className="w-full animate-pulse">
          <div className="flex flex-col gap-2">
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className={s.navigationItem}>
                <div className={s.skeletonCircle} />
                <div className={`${s.skeletonText} w-32`} />
              </div>
            ))}

            <hr className={s.divider} />

            {[1, 2, 3].map((item) => (
              <div key={`secondary-${item}`} className={s.navigationItem}>
                <div className={s.skeletonCircle} />
                <div
                  className={`${s.skeletonText} ${item === 1 ? "w-20" : item === 2 ? "w-32" : "w-24"}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <DarkModePageLayout variant="fill">
        <div className="md:ml-56 h-full">
          <CenteredInfinityLoader
            color={`${tokens.colors.neutral[200]}B3`}
            height="full"
          />
        </div>
      </DarkModePageLayout>
    </>
  );
}
